import React from "react";
import { Img, staticFile } from "remotion";

export interface WeeklyPass3DBadgeProps {
  price?: string;
  originalPrice?: string;
  tag?: string;
  translateZ?: number;
  rotateY?: number;
  scale?: number;
  translateY?: number;
}

export const WeeklyPass3DBadge: React.FC<WeeklyPass3DBadgeProps> = ({
  price = "Rp 27.500",
  originalPrice = "Rp 35.000",
  tag = "BEST VALUE",
  translateZ = 110,
  rotateY = 12,
  scale = 1,
  translateY = 0,
}) => {
  return (
    <div
      style={{
        position: "absolute",
        top: 80,
        left: -35, // Breaking card left boundary!
        transformStyle: "preserve-3d",
        transform: `translateZ(${translateZ}px) translateY(${translateY}px) scale(${scale}) rotateY(${rotateY}deg)`,
        backgroundColor: "#FFFFFF",
        borderRadius: 26,
        border: "2px solid #5D3FD3",
        padding: "18px 24px",
        boxShadow: "0 20px 45px rgba(93, 63, 211, 0.25), 0 8px 15px rgba(0,0,0,0.06)",
        display: "flex",
        alignItems: "center",
        gap: 16,
        zIndex: 35,
      }}
    >
      {/* Official 3D Weekly Diamond Pass Clean Cutout */}
      <div style={{ width: 68, height: 68, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Img
          src={staticFile("assets_library/items/weekly_diamond_pass_3d.png")}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            filter: "drop-shadow(0 6px 14px rgba(93, 63, 211, 0.35))",
          }}
        />
      </div>

      <div>
        <div
          style={{
            backgroundColor: "#FFB020",
            color: "#FFFFFF",
            fontFamily: "'Chakra Petch', sans-serif",
            fontSize: 11,
            fontWeight: 700,
            padding: "3px 10px",
            borderRadius: 8,
            display: "inline-block",
            marginBottom: 4,
          }}
        >
          {tag}
        </div>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 26, letterSpacing: "0.02em" }}>
          WEEKLY DIAMOND PASS
        </div>
        <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
          <span style={{ fontFamily: "'Anton', sans-serif", fontSize: 32, color: "#5D3FD3" }}>
            {price}
          </span>
          {originalPrice && (
            <span style={{ fontFamily: "'Rajdhani', sans-serif", fontSize: 16, color: "#94A3B8", textDecoration: "line-through", fontWeight: 700 }}>
              {originalPrice}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
